import templateStr from 'text!./bop-location-header.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            isPrimary: '&',
            displayName: '&',
            numBuildings: '&',
            isAccordionOpen: '=',
            primaryMarkNextLine: '&',
            showBuilding: '&',
            showActions: '&',
            showCarrot: '&',
            wide: '&',
            locationId: '&',
            onRemove: '&',
            onEdit: '&'
        },
        controller: function controller($scope) {
            $scope.hasNumBuildingsInfo = function () {
                return typeof $scope.numBuildings() === 'number';
            };

            $scope.removeLocation = function () {
                if (typeof $scope.onRemove() === 'function') {
                    $scope.onRemove()();
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/directives/bop-location-directive/BOPLocationHeader.js
// module id = 976
// module chunks = 0